import { styled } from '@/shared/styles/theme'
import { Title } from '@/shared/ui/Typography'

export const FormDescription = styled('div', {
  width: '100%',
  height: 'fit-content',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
})

FormDescription.displayName = 'FormDescription'
